// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as PnMStoreEn$PorterinFeature from "../../../domain/store/PnMStoreEn.mjs";
import * as PnmBookingFlowErrorBoundaryModuleScss from "@porterin/feature/src/containers/pnm/view/styles/PnmBookingFlowErrorBoundary.module.scss";

function PnmErrorBoundary(Props) {
  var on_click_retry = Props.on_click_retry;
  return React.createElement("div", {
              className: PnmBookingFlowErrorBoundaryModuleScss["error-screen-container"]
            }, React.createElement("div", {
                  className: PnmBookingFlowErrorBoundaryModuleScss["error-screen-main"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: PnMStoreEn$PorterinFeature.errorIconUrl,
                      height: 83.33,
                      width: 83.33,
                      alt: PnMStoreEn$PorterinFeature.errorIconAlt
                    }), React.createElement("div", {
                      className: PnmBookingFlowErrorBoundaryModuleScss["main-text"]
                    }, PnMStoreEn$PorterinFeature.something_went_wrong), React.createElement("div", {
                      className: PnmBookingFlowErrorBoundaryModuleScss["sub-text"]
                    }, PnMStoreEn$PorterinFeature.failed_to_process_your_request), React.createElement("button", {
                      className: PnmBookingFlowErrorBoundaryModuleScss["try-again-cta"],
                      onClick: (function (param) {
                          Curry._1(on_click_retry, undefined);
                        })
                    }, PnMStoreEn$PorterinFeature.close)));
}

var make = PnmErrorBoundary;

export {
  make ,
}
/* react Not a pure module */
